import React, { Component } from "react";
import { Button, Form, Image, Row } from "react-bootstrap";
import configData from "../config.json";
import { toast } from "react-toastify";
import "./Abha.css";
import Aadhaar from "./Aadhaar.png";
import mobile from "./mobile.png";
export default class AbhaVerification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requestId: sessionStorage.getItem("requestId"),
      aadharNumber: sessionStorage.getItem("aadhaarNumber"),
      abhaotp: ["", "", "", "", "", ""],
      AbhaProfile: {},
      abhanumber: ["", "", "", ""],
      mobile: "",
      showOtp: false,
      showAbha: false,
      cabhaaddress: "",
      custshowAddess: false,
      isAbhaVerifiedReady: false,
      authMethods: "",
      resendTimer: 60, // 1 minutes
      resendEnabled: false,
      resendIntervalId: null,

      // ["AADHAAR_OTP", "MOBILE_OTP"]
    };
  }
  startResendCountdown = () => {
    this.setState({
      resendEnabled: false,
      resendOtpANCount: this.state.resendOtpANCount + 1,
      resendTimer: 60,
    });
    const intervalId = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.resendTimer <= 1) {
          clearInterval(this.state.resendIntervalId);
          return { resendEnabled: true, resendTimer: 0 };
        }
        return { resendTimer: prevState.resendTimer - 1 };
      });
    }, 1000);
    this.setState({ resendIntervalId: intervalId });
  };
  formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds
    ).padStart(2, "0")}`;
  };

  ResendOTP = (e) => {
    e.preventDefault();
    let resendCount = parseInt(sessionStorage.getItem("resendOtpANCount")) || 0;
    if (resendCount >= 2) {
      this.showToast("Maximum resend attempts reached.", "error");
      return;
    }
    const formData = new FormData();
    formData.append("requestId", this.state.requestId);

    fetch(configData.api_url + "C_Abhadetails/resendAbhaOtp", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.success);
        if (data.status === "success") {
          sessionStorage.setItem("resendOtpANCount", resendCount + 1);
          clearInterval(this.state.resendIntervalId);
          // Restart timer after resending
        }
      });
  };
  componentDidMount() {
    this.ResponseHandler();

    const abhanumberRaw = sessionStorage.getItem("abhanumber");
    if (abhanumberRaw) {
      const abhaPlain = abhanumberRaw.replace(/-/g, ""); // Remove dashes
      if (abhaPlain.length === 14) {
        const abhaSplit = [
          abhaPlain.slice(0, 2),
          abhaPlain.slice(2, 6),
          abhaPlain.slice(6, 10),
          abhaPlain.slice(10, 14),
        ];
        this.setState({ abhanumber: abhaSplit });
      }
    }
    if (!sessionStorage.getItem("resendOtpANCount")) {
      sessionStorage.setItem("resendOtpANCount", "0");
    }
    this.startResendCountdown();
  }
  ResponseHandler = () => {
    var formData = new FormData();

    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhadetails/retriverequestId", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success" && data.detail) {
          const abhaDetails = JSON.parse(data.detail.abhaprofile);
          // console.log(abhaDetails);
          const abhaProfile = abhaDetails.ABHAProfile;
          //  const abhanumber = data.detail.abhanumber;

          if (abhaProfile)
            this.setState({
              AbhaProfile: abhaProfile,
              abhanumber: this.state.abhanumber,
            });
          else {
            window.location = "/consent";
          }
        }
      });
  };
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'
        break;
      default:
        toast.info(msg);
    }
  };

  handleabhaIdChange = (index, value) => {
    const updated = [...this.state.abhanumber];
    const limit = index === 0 ? 2 : 4;
    updated[index] = value.replace(/\D/g, "").slice(0, limit);
    this.setState({ abhanumber: updated });
  };

  handleabhaotpChange = (e, index) => {
    const val = e.target.value;
    if (/^\d?$/.test(val)) {
      // allow only single digit or empty
      this.setState(
        (prevState) => {
          const newOtp = [...prevState.abhaotp];
          newOtp[index] = val;
          return { abhaotp: newOtp };
        },
        () => {
          // auto focus next input if a digit was entered
          if (val && index < 5) {
            this[`otpInput${index + 1}`].focus();
          }
        }
      );
    }
  };
  handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !this.state.abhaotp[index] && index > 0) {
      this[`otpInput${index - 1}`].focus();
    }
  };

  handleSubmitNext = (e) => {
    e.preventDefault();
    const { abhanumber, authMethods } = this.state;
    const fullabhanumber = `${abhanumber[0]}-${abhanumber[1]}-${abhanumber[2]}-${abhanumber[3]}`;
    const abhaPlain = abhanumber.join("");
    const abhaRegex = /^\d{14}$/;
    if (!abhaRegex.test(abhaPlain)) {
      this.showToast("ABHA number must be exactly 14 digits.", "error");
      return;
    }
    sessionStorage.setItem("abhanumber", abhanumber.join("-"));
    var formData = new FormData();

    formData.append("abhanumber", fullabhanumber);
    formData.append("authMethods", authMethods);
    formData.append("requestId", sessionStorage.getItem("requestId"));

    fetch(configData.api_url + "C_Abhadetails/submitAbhaNumber", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.success);
        if (data.status === "success") {
          sessionStorage.setItem("resendOtpANCount", "");
          this.setState({
            responseMessage: data.details.message,
            message: data.message,
            showMessage: true,
          });
        } else {
          this.setState({
            responseMessage: "Something Went Wrong",
            showMessage: true,
          });
        }
      });
  };
  handleSubmitOTPNext = (e) => {
    e.preventDefault();
    const { abhanumber, aadharNumber } = this.state;
    const abhaotp = this.state.abhaotp.join("");

    sessionStorage.setItem("abhaotp", this.state.abhaotp);
    var formData = new FormData();

    formData.append("abhaotp", abhaotp);
    formData.append("requestId", sessionStorage.getItem("requestId"));

    fetch(configData.api_url + "C_Abhadetails/submitAbhaOtp", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.success);

        if (data.status === "success") {
          sessionStorage.setItem("aadharNumber", aadharNumber);
          sessionStorage.setItem("resendOtpANCount", "");
          sessionStorage.setItem("abhanumber", abhanumber.join("-"));
          window.location.href = "/abhaaddressverification";

          this.setState({
            resendOtpANCount: "",
          });
        }
      });
  };

  toggleOtpVisibility = () => {
    this.setState((prevState) => ({ showOtp: !prevState.showOtp }));
  };

  HandleClick = () => {
    this.setState({ isSubmitting: true });
    var formData = new FormData();
    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhadetails/retriveAbhacard", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message);
        if (data.status === "success") {
          this.handleDownloadPng(data.details);
        }
        this.setState({
          isSubmitting: false,
        });
      });
  };

  HandleShareClickClick = () => {
    this.setState({ isSubmitting: true });
    var formData = new FormData();
    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhadetails/retriveAbhacard", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message);
        if (data.status === "success") {
          this.handleDownloadPng(data.details);
        }
        this.setState({
          isSubmitting: false,
        });
      });
  };

  HandleQRCodeClickClick = () => {
    this.setState({ isSubmitting: true });
    var formData = new FormData();
    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhadetails/retriveAbhacard", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message);
        if (data.status === "success") {
          this.handleDownloadPng(data.details);
        }
        this.setState({
          isSubmitting: false,
        });
      });
  };
  handleDownloadPng = (imageUrl) => {
    const filename = imageUrl.split("/").pop();
    const link = document.createElement("a");
    link.href = imageUrl;
    link.target = "_blank";
    link.download = filename; // Desired filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  HandleNextSubmit = () => {
    window.location.href = "/abhaprofile";
  };
  HandleNewClick = () => {
    const { abhanumber, aadharNumber } = this.state;
    sessionStorage.setItem("aadharNumber", aadharNumber);
    sessionStorage.setItem("abhanumber", abhanumber.join("-"));
    // sessionStorage.setItem("abhaAddress", abhaAddress);

    window.location.href = "/abhaaddresscreation";
  };

  handleImageClick = (option) => {
    this.setState({ authMethods: option });
  };
  render() {
    const {
      abhanumber,
      abhaotp,
      showAbha,
      authMethods,
      resendEnabled,
      resendTimer,
    } = this.state;
    return (
      <div>
        <div className="row justify-content-md-center text-center abhaverification">
          <div className="col-md-6">
            <div className="widget_BG widget_BG_grid mb-2">
              <Form.Group>
                <Form.Label>
                  <b>ABHA Number</b>
                </Form.Label>
                <br />
                {abhanumber}
                <div className="d-flex gap-2">
                  {abhanumber.map((val, idx) => (
                    <Form.Control
                      className="otp-input-box"
                      key={idx}
                      tabIdx={idx + 1}
                      id={`abhanumber-${idx}`}
                      type={showAbha ? "text" : "password"}
                      value={val}
                      onChange={(e) =>
                        this.handleabhaIdChange(idx, e.target.value)
                      }
                      maxLength={idx === 0 ? 2 : 4}
                      placeholder={idx === 0 ? "XX" : "XXXX"}
                    />
                  ))}
                  <Button
                    variant="outline-secondary"
                    className={`rounded-0 bi ${
                      this.state.showAbha ? "bi-eye-slash" : "bi-eye"
                    }`}
                    onClick={() => this.setState({ showAbha: !showAbha })}
                  />
                </div>
                <br />
                <div className="row justify-content-md-center">
                  <p>Validate using</p>

                  <div className="col text-center">
                    <div
                      onClick={() => this.handleImageClick("aadhaarotp")}
                      style={{
                        border:
                          authMethods === "aadhaarotp"
                            ? "2px solid blue"
                            : "1px solid #ccc",
                        padding: "10px",
                        cursor: "pointer",
                        borderRadius: "5px",
                      }}
                    >
                      <Image
                        src={Aadhaar}
                        className="navbar-brand pe-3 ps-4 ps-lg-2"
                        alt="Aadhaar"
                        style={{
                          width: "auto",
                          height: "44px",
                          marginBottom: "5px",
                        }}
                      />
                      <Form.Check
                        label="Aadhaar OTP"
                        name="otpMethod"
                        type="radio"
                        disabled
                        checked={authMethods === "aadhaarotp"}
                      />
                    </div>
                  </div>

                  <div className="col text-center">
                    <div
                      onClick={() => this.handleImageClick("mobileotp")}
                      style={{
                        border:
                          authMethods === "mobileotp"
                            ? "2px solid blue"
                            : "1px solid #ccc",
                        padding: "10px",
                        cursor: "pointer",
                        borderRadius: "5px",
                      }}
                    >
                      <Image
                        src={mobile}
                        className="navbar-brand pe-3 ps-4 ps-lg-2"
                        alt="Mobile"
                        style={{
                          width: "auto",
                          height: "44px",
                          marginBottom: "5px",
                        }}
                      />
                      <Form.Check
                        label="Mobile OTP"
                        name="otpMethod"
                        type="radio"
                        disabled
                        checked={authMethods === "mobileotp"}
                      />
                    </div>
                  </div>
                </div>

                <Button
                  className="rounded-0 m-1"
                  onClick={this.handleSubmitNext}
                >
                  Verify ABHA Number
                </Button>
              </Form.Group>

              <Form.Group>
                <Form.Label>Enter OTP</Form.Label>
                {this.state.showMessage && (
                  <i style={{ color: "blue" }}>{this.state.message}</i>
                )}
                <div className="d-flex gap-2 text-center">
                  {abhaotp.map((digit, index) => (
                    <Form.Control
                      key={index}
                      type={this.state.showOtp ? "text" : "password"}
                      maxLength="1"
                      value={digit}
                      onChange={(e) => this.handleabhaotpChange(e, index)}
                      onKeyDown={(e) => this.handleOtpKeyDown(e, index)}
                      ref={(input) => (this[`otpInput${index}`] = input)}
                      className="form-control"
                    />
                  ))}

                  <Button
                    variant="outline-secondary"
                    className={`rounded-0 bi ${
                      this.state.showOtp ? "bi-eye-slash" : "bi-eye"
                    }`}
                    onClick={this.toggleOtpVisibility}
                  />
                </div>
                <div as={Row}>
                  <div className="col">
                    {parseInt(sessionStorage.getItem("resendOtpANCount")) >=
                    2 ? (
                      <div style={{ color: "red", fontWeight: "bold" }}>
                        Resend OTP not working
                      </div>
                    ) : (
                      <Button
                        className="rounded-0 m-1"
                        variant="warning"
                        onClick={this.ResendOTP}
                        disabled={!resendEnabled}
                      >
                        Resend OTP{" "}
                        {!resendEnabled && `in ${this.formatTime(resendTimer)}`}
                      </Button>
                    )}
                  </div>
                </div>
              </Form.Group>
            </div>
          </div>
        </div>
        <div className="row  widget_BG widget_BG_grid m-0 mt-2">
          <div className="col text-end">
            <Button
              className="rounded-0 m-1"
              disabled={abhaotp.some(((d) => d === "") || abhaotp !== 6)}
              onClick={this.handleSubmitOTPNext}
            >
              {this.state.isSubmitting
                ? "Submitting..."
                : "Verify\u00A0ABHAOTP"}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
